import { Capacitor } from '@capacitor/core';

// Recordatorio local simple (no una alarma nativa a pantalla completa como
// las dosis de medicamentos) — se usa para avisos que no necesitan sonar
// aunque el teléfono esté bloqueado, solo aparecer como notificación normal
// del sistema. Reutilizado por Quedadas y por los avisos de vacunas Premium.
export const scheduleLocalReminder = async (id: number, title: string, body: string, at: Date) => {
    if (!Capacitor.isNativePlatform()) return;
    if (isNaN(at.getTime()) || at.getTime() <= Date.now()) return;
    try {
        const { LocalNotifications } = await import('@capacitor/local-notifications');
        const perm = await LocalNotifications.checkPermissions();
        if (perm.display !== 'granted') await LocalNotifications.requestPermissions();
        await LocalNotifications.schedule({
            notifications: [{ id, title, body, schedule: { at } }]
        });
    } catch { /* el recordatorio es un plus, no bloquea el flujo si falla */ }
};

// Igual que arriba, pero se repite todos los días desde `at` en adelante —
// para alertas rojas que deben seguir insistiendo hasta que algo se marque
// como resuelto (ej. una vacuna vencida hasta que se registre la puesta),
// en vez de avisar una sola vez y desaparecer.
export const scheduleDailyReminder = async (id: number, title: string, body: string, at: Date) => {
    if (!Capacitor.isNativePlatform()) return;
    if (isNaN(at.getTime())) return;
    // Si la fecha de inicio ya pasó, arranca hoy a la misma hora para que
    // empiece a insistir de inmediato en vez de esperar un año a que la
    // hora vuelva a coincidir.
    let start = at;
    if (start.getTime() <= Date.now()) {
        start = new Date();
        start.setHours(at.getHours(), at.getMinutes(), 0, 0);
        if (start.getTime() <= Date.now()) start.setDate(start.getDate() + 1);
    }
    try {
        const { LocalNotifications } = await import('@capacitor/local-notifications');
        const perm = await LocalNotifications.checkPermissions();
        if (perm.display !== 'granted') await LocalNotifications.requestPermissions();
        await LocalNotifications.schedule({
            notifications: [{ id, title, body, schedule: { at: start, repeats: true, every: 'day' } }]
        });
    } catch { /* el recordatorio es un plus, no bloquea el flujo si falla */ }
};

export const cancelLocalReminder = async (id: number) => {
    if (!Capacitor.isNativePlatform()) return;
    try {
        const { LocalNotifications } = await import('@capacitor/local-notifications');
        await LocalNotifications.cancel({ notifications: [{ id }] });
    } catch { /* nada que cancelar */ }
};
